export default __webpack_public_path__ + "images/cancerfondsrapporten/piechart-33.png";